import { forwardRef, type SVGProps } from 'react'
import { HugeiconsIcon, type IconSvgElement } from '@hugeicons/react'
import {
  Add01Icon,
  AiMagicIcon,
  Alert02Icon,
  AlertCircleIcon,
  AnalyticsUpIcon,
  ArrowDown01Icon,
  ArrowLeft01Icon,
  ArrowRight01Icon,
  ArrowUpRight01Icon,
  Building04Icon,
  Building03Icon,
  Calculator01Icon,
  Calendar03Icon,
  CheckmarkCircle02Icon,
  CircleIcon,
  Clock01Icon,
  Copy01Icon,
  Delete02Icon,
  Edit02Icon,
  File01Icon,
  FolderOpenIcon,
  GoogleIcon,
  GridViewIcon,
  InboxIcon,
  InformationCircleIcon,
  Key01Icon,
  Link01Icon,
  Loading03Icon,
  Mail01Icon,
  PlayCircle02Icon,
  Rocket01Icon,
  Presentation01Icon,
  Search01Icon,
  Satellite03Icon,
  Settings02Icon,
  SparklesIcon,
  Tick02Icon,
  TimeQuarter02Icon,
  Upload02Icon,
  UserCircleIcon,
  UserGroupIcon,
  Video01Icon,
  ViewIcon,
  WorkflowCircle04Icon,
  CustomerSupportIcon,
  HeadsetIcon,
  Cancel01Icon,
  Heading02Icon,
  Heading03Icon,
  LeftToRightListBulletIcon,
  LeftToRightListNumberIcon,
  TextBoldIcon,
  TextItalicIcon,
  Unlink01Icon,
  Download04Icon,
  Home01Icon,
  HandshakeIcon,
} from '@hugeicons/core-free-icons'

export type IconProps = SVGProps<SVGSVGElement> & {
  size?: number | string
  weight?: string
}

function createIcon(icon: IconSvgElement, displayName: string) {
  const Component = forwardRef<SVGSVGElement, IconProps>(function PrentusIcon(
    { weight: _weight, strokeWidth = 1.8, ...props },
    ref,
  ) {
    return <HugeiconsIcon ref={ref} icon={icon} strokeWidth={Number(strokeWidth)} {...props} />
  })
  Component.displayName = displayName
  return Component
}

export const ArrowLeft = createIcon(ArrowLeft01Icon, 'ArrowLeft')
export const ChevronDown = createIcon(ArrowDown01Icon, 'ChevronDown')
export const AiMagic = createIcon(AiMagicIcon, 'AiMagic')
export const ArrowRight = createIcon(ArrowRight01Icon, 'ArrowRight')
export const ArrowSquareOut = createIcon(ArrowUpRight01Icon, 'ArrowSquareOut')
export const Buildings = createIcon(Building03Icon, 'Buildings')
export const BuildingOffice = createIcon(Building04Icon, 'BuildingOffice')
export const CalendarBlank = createIcon(Calendar03Icon, 'CalendarBlank')
export const Check = createIcon(Tick02Icon, 'Check')
export const CheckCircle = createIcon(CheckmarkCircle02Icon, 'CheckCircle')
export const Circle = createIcon(CircleIcon, 'Circle')
export const Clock = createIcon(Clock01Icon, 'Clock')
export const ClockCounterClockwise = createIcon(TimeQuarter02Icon, 'ClockCounterClockwise')
export const Copy = createIcon(Copy01Icon, 'Copy')
export const EnvelopeSimple = createIcon(Mail01Icon, 'EnvelopeSimple')
export const Eye = createIcon(ViewIcon, 'Eye')
export const File = createIcon(File01Icon, 'File')
export const FolderOpen = createIcon(FolderOpenIcon, 'FolderOpen')
export const Gear = createIcon(Settings02Icon, 'Gear')
export const GoogleLogo = createIcon(GoogleIcon, 'GoogleLogo')
export const Info = createIcon(InformationCircleIcon, 'Info')
export const Key = createIcon(Key01Icon, 'Key')
export const LinkSimple = createIcon(Link01Icon, 'LinkSimple')
export const LockKey = createIcon(Key01Icon, 'LockKey')
export const PencilSimple = createIcon(Edit02Icon, 'PencilSimple')
export const PlayCircle = createIcon(PlayCircle02Icon, 'PlayCircle')
export const Plus = createIcon(Add01Icon, 'Plus')
export const PresentationChart = createIcon(Presentation01Icon, 'PresentationChart')
export const Search = createIcon(Search01Icon, 'Search')
export const Satellite = createIcon(Satellite03Icon, 'Satellite')
export const Sparkles = createIcon(SparklesIcon, 'Sparkles')
export const SpinnerGap = createIcon(Loading03Icon, 'SpinnerGap')
export const SquaresFour = createIcon(GridViewIcon, 'SquaresFour')
export const TrendUp = createIcon(AnalyticsUpIcon, 'TrendUp')
export const Trash = createIcon(Delete02Icon, 'Trash')
export const UploadSimple = createIcon(Upload02Icon, 'UploadSimple')
export const UserCircle = createIcon(UserCircleIcon, 'UserCircle')
export const Users = createIcon(UserGroupIcon, 'Users')
export const VideoCamera = createIcon(Video01Icon, 'VideoCamera')
export const Workflow = createIcon(WorkflowCircle04Icon, 'Workflow')
export const CustomerSupport = createIcon(CustomerSupportIcon, 'CustomerSupport')
export const Headset = createIcon(HeadsetIcon, 'Headset')
export const X = createIcon(Cancel01Icon, 'X')
export const Warning = createIcon(Alert02Icon, 'Warning')
export const WarningCircle = createIcon(AlertCircleIcon, 'WarningCircle')
export const Inbox = createIcon(InboxIcon, 'Inbox')
export const Rocket = createIcon(Rocket01Icon, 'Rocket')
export const Heading2 = createIcon(Heading02Icon, 'Heading2')
export const Heading3 = createIcon(Heading03Icon, 'Heading3')
export const ListBullets = createIcon(LeftToRightListBulletIcon, 'ListBullets')
export const ListNumbers = createIcon(LeftToRightListNumberIcon, 'ListNumbers')
export const TextBold = createIcon(TextBoldIcon, 'TextBold')
export const TextItalic = createIcon(TextItalicIcon, 'TextItalic')
export const LinkBreak = createIcon(Unlink01Icon, 'LinkBreak')
export const DownloadSimple = createIcon(Download04Icon, 'DownloadSimple')
export const House = createIcon(Home01Icon, 'House')
export const Handshake = createIcon(HandshakeIcon, 'Handshake')
export const Calculator = createIcon(Calculator01Icon, 'Calculator')
